// One design system for every page. Change a value here and the whole site follows (index.css mirrors these as CSS variables).
export const COLORS = {
  bg: "#F6F1E7",        // warm beige page background
  surface: "#FFFDF8",   // cards, header, panels
  panel: "#F0E7D6",     // soft beige section band
  ink: "#2B2117",       // headings / body
  muted: "#7A6552",     // secondary text
  gold: "#C9A23F",      // brand accent (lines, eyebrows, dividers)
  goldSoft: "#E8B33A",
  red: "#9E3B3B",       // primary action
  redDeep: "#7E2E2E",
  line: "rgba(201,162,63,0.35)",
};

export const FONTS = {
  display: "'Yeseva One', serif",
  body: "'Poppins', sans-serif",
};

export const RADIUS = { card: "1rem", pill: "9999px" };

// Shared class recipes — use these instead of ad-hoc Tailwind colour classes on pages.
export const T = {
  page: "ut-page",
  container: "max-w-7xl mx-auto px-5 sm:px-8",
  eyebrow: "ut-eyebrow",
  h1: "ut-h1",
  h2: "ut-h2",
  lead: "ut-lead",
  card: "ut-card",
  btn: "ut-btn",
  btnPrimary: "ut-btn ut-btn-primary",
  btnGhost: "ut-btn ut-btn-ghost",
  divider: "ut-divider",
};
